module.exports = __webpack_public_path__ + "img/indoor.2fca365b.png";